import { mapActions, mapGetters } from "vuex";
import { GlobalService } from "@/services/GlobalService";

export const crewMedicalMixin = {

  data() {
    return {
      crewMedical: {},
      crewMedicalHistories: [],
      crewMedicalError: {},
      crewMedicalId: null,
      medicalTitle: '',
      crewMedicalPath: GlobalService.apiUrl()+'viewCrewMedical'
    }
  },

  methods: {
    ...mapActions(['getCrewMedicals','getCrewMedicalFile']),

    refreshCrewMedical() {
      this.crewMedical = {};
      this.crewMedicalError = {};
    },

    // updateCrewMedicalModal(crewMedical) {
    //   this.refreshCrewMedical();
    //   this.crewMedical = Object.assign({}, crewMedical);
    //   this.crewMedicalId = crewMedical.id;
    //   this.medicalTitle = crewMedical.name;
    //   // this.getCrewMedicalFile(this.crewMedical.id);
    //   // this.getCrewDocumentHistory({crewId: this.crew.id, documentId: this.crewDocumentId})
    // },
  },

  computed: {
    ...mapGetters([
      'crew',
      'printMultipleParams',
      'crewMedicals'
    ])
  },

}
